import { render, staticRenderFns } from "./SqlEditor.vue?vue&type=template&id=0ca954f6&lang=pug"
import script from "./SqlEditor.vue?vue&type=script&lang=js"
export * from "./SqlEditor.vue?vue&type=script&lang=js"
import style0 from "./SqlEditor.vue?vue&type=style&index=0&id=0ca954f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VSelect,VSpacer,VTextarea})
